module.exports = __webpack_public_path__ + "img/无锡玖城二手车交易市场有限公司.db3ba63f.png";